//Init all inputs of page
initInputs();


//Multiselect
$(document).click(function(e) {
    let clicked = $(e.target);
    $('.multi-select').each(function() {
        if ($(this).hasClass('active') && !$(this).has(clicked).length) {
            toggleSelect($(this));
        }
    })
});
$('.multi-select').bind('keypress', function (e) { //add tabs accesibility
    if (e.keyCode == 13) {//if its a enter key
        toggleSelect($(this))
    }
});
function toggleSelect(select) {
    select.find('.items').slideToggle(150);
    select.toggleClass('active');
    toggleAreaExpend(select)
}


export function toggleAreaExpend(element) {
    let ariaExpanded = element.attr("aria-expanded")
    if (ariaExpanded === "true") {
        element.attr("aria-expanded", 'false')
    } else if (ariaExpanded === "false"){
        element.attr("aria-expanded", 'true')
    }
}

//Init inputs
export function initInputs(container = $(document)) {

    //Radio
    container.find(".input-radio label").each(function (e) {
        let $label = $(this).html();
        $(this).html('<span class="box"></span><span>'+$label+'</span>');
    });
    container.find(".input-radio input[type=radio]:checked").each(function (e) {
        $(this).parent().addClass('checked')
    });
    container.find(".input-radio input[type=radio]").change(function (e) {
        $(this).parent().addClass('checked');
        container.find(".input-radio input[type=radio]").each(function (e) {
            $(this).parents('.input-radio').each(function () {
                if (!$(this).find('input[type=radio]:checked').length) {
                    $(this).removeClass('checked');
                }
            });
        });
    }).focusin(function() {
        $(this).parent().addClass('focus');
    }).focusout(function() {
        $(this).parent().removeClass('focus');
    });

    //Checkbox
    container.find(".input-checkbox label").each(function (e) {
        let $label = $(this).html();
        $(this).html('<span class="box"></span><span>'+$label+'</span>');
    });
    container.find(".input-checkbox input[type=checkbox]:checked").each(function (e) {
        $(this).parent().addClass('checked')
    });
    container.find(".input-checkbox input[type=checkbox]").change(function (e) {
        var checked = $(this).is(':checked');
        if (checked) {
            $(this).parent().addClass('checked');
        } else {
            $(this).parent().removeClass('checked');
        }
    }).focusin(function() {
        $(this).parent().addClass('focus');
    }).focusout(function() {
        $(this).parent().removeClass('focus');
    });

    //Filter Checkbox
    container.find(".checkbox label").each(function (e) {
        let $label = $(this).html();
        $(this).html('<span class="box"></span><span>'+$label+'</span>');
    });
    container.find(".checkbox input[type=checkbox]:checked").each(function (e) {
        $(this).parent().addClass('checked')
    });
    container.find(".checkbox input[type=checkbox]").change(function (e) {
        var checked = $(this).is(':checked');
        if (checked) {
            $(this).parent().addClass('checked');
        } else {
            $(this).parent().removeClass('checked');
        }
    }).focusin(function() {
        $(this).parent().addClass('focus');
    }).focusout(function() {
        $(this).parent().removeClass('focus');
    });

    //Input Text
    container.find(".input-text [name]").each(function (e) {
        $(this).focus(function (e) {
            $(this).parent().addClass('active');
        });
        $(this).blur(function (e) {
            if (!$(this).val()) $(this).parent().removeClass('active');
        })
    });

    //Select
    container.find(".select select").focusin(function() {
        $(this).parent().addClass('focus');
    }).focusout(function() {
        $(this).parent().removeClass('focus');
    });

    //Multiselect
    container.find(".multi-select").each(function (e) {
        $(this).attr('tabindex', 0);
        $(this).attr('aria-expanded', 'false');
        $(this).find('.label').click(function (e) {
            toggleSelect($(this).parent());
        });
    });

    //toggle
    container.find(".input-toggle").each(function (e) {
        $(this).attr('tabindex', 0);
        $(this).attr('aria-expanded', 'false');
        $(this).click(function (e) {
            $(this).toggleClass('checked')
            toggleSelect($(this).parent());
        });
    });

    container.find(".input-toggle input[type=checkbox]:checked").each(function (e) {
        $(this).parent().addClass('checked')
    });
    container.find(".input-toggle input[type=checkbox]").change(function (e) {
        var checked = $(this).is(':checked');
        if (checked) {
            $(this).parent().addClass('checked');
        } else {
            $(this).parent().removeClass('checked');
        }
    }).focusin(function() {
        $(this).parent().addClass('focus');
    }).focusout(function() {
        $(this).parent().removeClass('focus');
    });
}
